import type { Channel } from "@/types/working-model";

type EncodedCustomizations = {
	html: Channel["customizations"]["html"] & { encoding: string };
	css: Channel["customizations"]["css"];
}
export type ChannelSafeCustom = Channel & {
	customizations: EncodedCustomizations
}

export const channelWithObscuredCustomHtml = (updatedChannel: Channel): ChannelSafeCustom => {
	const obscuredCustomHtml: Channel["customizations"]["html"] & { encoding: string } = {
		events: {
			all: "",
		},
		sessions: {
			all: "",
		},
		encoding: "hex",
	};

	const encoder = new TextEncoder();

	for (const [key, value] of Object.entries(updatedChannel.customizations.html.events)) {
		obscuredCustomHtml.events[key] = encoder.encode(value).toHex();
	}

	for (const [key, value] of Object.entries(updatedChannel.customizations.html.sessions)) {
		obscuredCustomHtml.sessions[key] = encoder.encode(value).toHex();
	}

	return {
		...updatedChannel,
		customizations: {
			...updatedChannel.customizations,
			html: obscuredCustomHtml,
		},
	};
};